import { NOTIFICATION_USER_LIST } from "../../constants/actionConstants";

const initialState = {

  users:[]
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_USER_LIST:
      return { ...state, users: action.payload };
    default:
      return state;
  }
};
